module.exports = __webpack_public_path__ + "img/27.e6c90f92.png";